import React, {ReactNode} from "react";
import {Tab, Tabs} from "material-ui";
import {TabTemplate} from "../../../core/common/config/mui-theme";
import {observer} from "mobx-react";
import {Criterion, CRITERIONTYPE} from "../../domain/criterion/criterionDomain";
import SbToolProjectVersionService from "../../service/projectVersionService";
import {action} from "mobx";
import {SubCriterion, SUBCRITERIONVALUESTYPE} from "../../domain/criterion/subCriterionDomain";
import ParametersListForm from "./parametersListForm";
import ParametersSelectForm from "./parametersSelectForm";
import sbToolParamsService from "../../service/paramsService";
import ProjectVersionParamsToolbar from "./projectVersionParamsToolbar";
import GridComp, {UILOCATION} from "../../../core/grid/component/gridComp";
import Grid from "../../../core/grid/domain/grid";
import mdEntityService from "../../../core/metamodel/mdEntityService";
import {
  PROJECT_VERSION_ENERGY_CARRIERS_LIST, PROJECT_VERSION_EPD_CERTIFIED_MATERIALS_LIST,
  PROJECT_VERSION_MATERIALS_GRID,
  PROJECT_VERSION_RECYCLABLE_MATERIALS_LIST, PROJECT_VERSION_WOOD_BASED_MATERIALS_GRID,
  PROJECT_VERSION_AREA_ZELPO_GRID,
  PROJECT_VERSION_AREA_ZELZP_GRID,
  PROJECT_VERSION_AREA_ZELZF_GRID,
  PROJECT_VERSION_AREA_ZELZS_GRID, PROJECT_VERSION_AREA_ZELST_GRID, PROJECT_VERSION_AREA_VPREP_GRID,PROJECT_VERSION_AREA_PEFKE_GRID
} from "../../gridsContants";
import ParametersMultiSelectForm from "./parametersMultiSelectForm";
import ParametersInputsForm from "./parametersInputsForm";
import ProjectVersionMaterialExpandComp from "../projectVersionMaterialExpandComp";
import ParametersComplexCriterionForm from "./parametersComplexCriterionForm";
import SubCriterionAreaList from "../../page/project/subCriterionAreaList";
import SidebarCriteriaMenu from "../ProjectVersionParamsForm/SidebarCriteriaMenu/SidebarCriteriaMenu";
import EvaluationGrid from "../ProjectVersionParamsForm/EvaluationGrid/EvaluationGrid";
import styled from "styled-components";



@observer
class ProjectVersionParamsForm extends React.Component<any, any> {

  state = {
    isValueChanged: false
  }
  componentDidMount() {
    sbToolParamsService.loadResults();
    sbToolParamsService.loadCriterionVersions();
  }

  @action
  private onSelectSubCriterion = (value: any, e: React.FormEvent<{}>, tab: Tab) => {
    let criterion: Criterion = sbToolParamsService.selectedCriterion
    let subCriterion = criterion.subCriteria.find(sc => sc.subCriterionId === Number(value))
    sbToolParamsService.selectedSubCriterion = subCriterion;
    console.warn("Selected sub criterion : " + subCriterion.name)
  }

  // Rendering second tabs line with sub criteria names
  renderSubCriteriaTabs = () => {
    let criterion = sbToolParamsService.selectedCriterion;
    if (!criterion) {
      return ""
    }

    if (criterion.criterionType === CRITERIONTYPE.COMPLEX) {

      const tab = (
        <Tab label={criterion.name}
             style={{
               minHeight: 50,
               whiteSpace: "break-spaces",
               backgroundColor: '#F9F9F9',
               borderRadius:5,
               padding: 10,
               boxShadow:" rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px",
        }}
             key={criterion.id}
             value={criterion.id}
        >
          {this.renderComplexSubCriterionForm(criterion)}
        </Tab>
      );

      return (
        <div style={{width: "100%", zIndex: 1}}>
          <ProjectVersionParamsToolbar isValueChanged={this.state.isValueChanged} handleChangeValueState={this.handleChangeValueState}/>
          <Tabs className="detail-grid"
                tabTemplate={TabTemplate}
                inkBarStyle={{transition: 'inherit'}}
                contentContainerStyle={{width: '100%', flexGrow: 1, display: 'flex', minHeight: 50}}
                style={{marginTop: 5, marginBottom: 5}}
                tabItemContainerStyle={{height : 100}}
          >
            {tab}
          </Tabs>
        </div>
      );
    }

    // Style for Tab for set height to fix text overrun form Tab element. Tab in HTML is button>div>div>#textNode
    const StyledTab = styled(Tab)`
    & div > div {
      height: fit-content !important;
    }
    `

    const subCriteriaTabArray = criterion.subCriteria.map((subCriterion, index) => (
      <StyledTab label={subCriterion.name}
           style={{
             minHeight: 50,
             whiteSpace: "break-spaces",
             backgroundColor: '#F9F9F9',
             borderRadius:5,
             padding: 10,
             boxShadow:"rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px",
           }}
           key={index}
           value={subCriterion.id}
      >
        {this.renderSubCriterionForm(subCriterion)}
      </StyledTab>
    ));

    return (subCriteriaTabArray.length) ? (

      <div style={{width: "75%", zIndex: 1}}>
        <ProjectVersionParamsToolbar isValueChanged={this.state.isValueChanged} handleChangeValueState={this.handleChangeValueState}/>
        <Tabs className="detail-grid"
              tabTemplate={TabTemplate}
              inkBarStyle={{transition: 'inherit'}}
              contentContainerStyle={{width: '100%', flexGrow: 1, display: 'flex', minHeight: "fit-content"}}
              style={{marginTop: 5, marginBottom: 5}}
              value={sbToolParamsService.selectedSubCriterion.id}
              onChange={this.onSelectSubCriterion}
              tabItemContainerStyle={{height : "fit-content"}}
        >
          {subCriteriaTabArray}
        </Tabs>
      </div>

    ) : '';
  }

  handleChangeValueState = (bool:boolean) => { this.setState({isValueChanged:bool})}
  // Rendering form for filling sub criterion
  private renderSubCriterionForm = (subCriterion: SubCriterion): ReactNode => {
    if (subCriterion.type === SUBCRITERIONVALUESTYPE.LIST) {
      return (<ParametersListForm subCriterion={subCriterion} handleChangeValueState={this.handleChangeValueState}/>)
    }
    if (subCriterion.type === SUBCRITERIONVALUESTYPE.SELECT) {
      return <ParametersSelectForm subCriterion={subCriterion} handleChangeValueState={this.handleChangeValueState}/>
    }
    if (subCriterion.type === SUBCRITERIONVALUESTYPE.MULTISELECT) {
      return <ParametersMultiSelectForm subCriterion={subCriterion} handleChangeValueState={this.handleChangeValueState}/>
    }
    if (subCriterion.type === SUBCRITERIONVALUESTYPE.INPUTS) {
      return <ParametersInputsForm subCriterion={subCriterion} handleChangeValueState={this.handleChangeValueState}/>
    }
    if (subCriterion.type === SUBCRITERIONVALUESTYPE.MATERIALS) {
      let materialsGrid : Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_MATERIALS_GRID) as Grid;
      console.error(materialsGrid.label);
      return <GridComp grid={materialsGrid} uiLocation={UILOCATION.tab} entities={mdEntityService.entityMap} hideGridConfig hideCopyRow showExpand={true} ExpandComponent={ProjectVersionMaterialExpandComp}/>
    }
    if (subCriterion.type === SUBCRITERIONVALUESTYPE.ENERGY_CARRIERS) {
      let grid : Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_ENERGY_CARRIERS_LIST) as Grid;
      console.error(grid.label);
      return <GridComp grid={grid} uiLocation={UILOCATION.tab} entities={mdEntityService.entityMap} hideGridConfig hideCopyRow />
    }
    if (subCriterion.type === SUBCRITERIONVALUESTYPE.AREAS) {
      const versionId = sbToolParamsService.selectedCriterionVersion.projectVersion.versionId;
      return <SubCriterionAreaList projectVersionId={versionId} subCriterionCode={subCriterion.code} />
    }
    if (subCriterion.type === SUBCRITERIONVALUESTYPE.RECYCLABLE_MATERIALS_GRID) {
      let materialsGrid : Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_RECYCLABLE_MATERIALS_LIST) as Grid;
      return <GridComp grid={materialsGrid} uiLocation={UILOCATION.tab} entities={mdEntityService.entityMap} hideGridConfig hideCopyRow />
    }
    if (subCriterion.type === SUBCRITERIONVALUESTYPE.EPD_CERTIFIED_MATERIALS_GRID) {
      let materialsGrid : Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_EPD_CERTIFIED_MATERIALS_LIST) as Grid;
      return <GridComp grid={materialsGrid} uiLocation={UILOCATION.tab} entities={mdEntityService.entityMap} hideGridConfig hideCopyRow />
    }
    if (subCriterion.type === SUBCRITERIONVALUESTYPE.WOOD_BASED_MATERIALS_GRID) {
      let materialsGrid : Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_WOOD_BASED_MATERIALS_GRID) as Grid;
      return <GridComp grid={materialsGrid} uiLocation={UILOCATION.tab} entities={mdEntityService.entityMap} hideGridConfig hideCopyRow />
    }
    if (subCriterion.type === SUBCRITERIONVALUESTYPE.AREAS_ZELPO_GRID) {
      let materialsGrid : Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_AREA_ZELPO_GRID) as Grid;
      return <GridComp grid={materialsGrid} uiLocation={UILOCATION.tab} entities={mdEntityService.entityMap} hideGridConfig hideCopyRow />
    }
    if (subCriterion.type === SUBCRITERIONVALUESTYPE.AREAS_ZELZP_GRID) {
      let materialsGrid : Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_AREA_ZELZP_GRID) as Grid;
      return <GridComp grid={materialsGrid} uiLocation={UILOCATION.tab} entities={mdEntityService.entityMap} hideGridConfig hideCopyRow />
    }
    if (subCriterion.type === SUBCRITERIONVALUESTYPE.AREAS_ZELZF_GRID) {
      let materialsGrid : Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_AREA_ZELZF_GRID) as Grid;
      return <GridComp grid={materialsGrid} uiLocation={UILOCATION.tab} entities={mdEntityService.entityMap} hideGridConfig hideCopyRow />
    }

    if (subCriterion.type === SUBCRITERIONVALUESTYPE.AREAS_ZELZS_GRID) {
      let materialsGrid : Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_AREA_ZELZS_GRID) as Grid;
      return <GridComp grid={materialsGrid} uiLocation={UILOCATION.tab} entities={mdEntityService.entityMap} hideGridConfig hideCopyRow />
    }

    if (subCriterion.type === SUBCRITERIONVALUESTYPE.AREAS_ZELST_GRID) {
      let materialsGrid : Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_AREA_ZELST_GRID) as Grid;
      return <GridComp grid={materialsGrid} uiLocation={UILOCATION.tab} entities={mdEntityService.entityMap} hideGridConfig hideCopyRow />
    }
    if (subCriterion.type === SUBCRITERIONVALUESTYPE.AREAS_VPREP_GRID) {
      let materialsGrid : Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_AREA_VPREP_GRID) as Grid;
      return <GridComp grid={materialsGrid} uiLocation={UILOCATION.tab} entities={mdEntityService.entityMap} hideGridConfig hideCopyRow />
    }
    if (subCriterion.type === SUBCRITERIONVALUESTYPE.AREAS_PEFKE_GRID) {
      let materialsGrid : Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_AREA_PEFKE_GRID) as Grid;
      return <GridComp grid={materialsGrid} uiLocation={UILOCATION.tab} entities={mdEntityService.entityMap} hideGridConfig hideCopyRow />
    }

    return <noscript/>
  };

  private renderComplexSubCriterionForm = (criterion: Criterion): ReactNode => {
    return <ParametersComplexCriterionForm criterion={criterion}  handleChangeValueState={this.handleChangeValueState}/>
  };

  render() {
    return (
      <div style={{width: "100%", minWidth: 768, borderTop: "1px solid #E7E7E7", marginTop:5}}>
        <div style={{display: "flex", gap: 50, marginTop: 10}}>
          <div style={{backgroundColor: "#F0F0F0", minHeight: "100vh"}}>
            <SidebarCriteriaMenu isValueChanged={this.state.isValueChanged} handleChangeValueState={this.handleChangeValueState}/>
          </div>
          <div style={{display: "flex", width: "79%", justifyContent: "space-between", gap: 50,}}>
            {this.renderSubCriteriaTabs()}
            <EvaluationGrid/>
          </div>
        </div>
      </div>);
  }
}

export default ProjectVersionParamsForm



// WEBPACK FOOTER //
// ./src/sbtool/component/parameter/projectVersionParamsForm.tsx